// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";

function makeProps(items_list, on_item_selection, selected_item, list_wrapper_class, errorOpt) {
  var error = errorOpt !== undefined ? Caml_option.valFromOption(errorOpt) : undefined;
  return {
          list: {
            items_list: items_list,
            list_wrapper_class: list_wrapper_class
          },
          selection: {
            on_item_selection: on_item_selection,
            selected_item: selected_item
          },
          error: error
        };
}

export {
  makeProps ,
}
/* No side effect */
